/**
 * Visitenkarten-Lightbox · Fullscreen-Bild mit Pinch-Zoom (touch-action).
 */
import { useEffect } from 'react';
import { X } from 'lucide-react';

interface Props {
  src: string;
  alt?: string;
  onClose: () => void;
}

export function CardLightbox({ src, alt, onClose }: Props) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="lightbox-overlay" onClick={onClose} role="dialog" aria-label="Visitenkarte">
      <button
        type="button"
        className="lightbox-close"
        onClick={onClose}
        aria-label="Schließen"
      >
        <X size={28} />
      </button>
      <img
        src={src}
        alt={alt ?? 'Visitenkarte'}
        className="lightbox-img"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
